import React from "react";
import CreateNFT from "./components/CreateNFT";
import SellNFT from "./components/SellNFT";
import Profile from "./components/Profile";
import NFTPage from "./components/NFTPage";
import Marketplace from "./components/Marketplace";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Marketplace />} />
        <Route path="/nftPage/:id" element={<NFTPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/sellNFT" element={<CreateNFT />} />
      </Routes>
    </>
  );
}

export default App;
